import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "rsuite/dist/rsuite.css";

function CreateOrderEditRfq({ show, onClose, rfqId }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    setValue,
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = async (formData) => {
    navigate("/create-order-lifecycle", { state: { rfqId } });
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header
          className="justify-content-center d-block text-center"
          closeButton
        >
          <Modal.Title className="tittle_deal">
            <span className="text-green">Congratulations</span> on closing the
            deal!
          </Modal.Title>
          <p className="mb-0">
            Please provide the following information to create a pending order
            and start fulfilling it.
          </p>
        </Modal.Header>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Footer className="justify-content-center">
            <Button variant="warning" type="submit">
              Finish Editing
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default CreateOrderEditRfq;
